import { JobsPanel } from "@/components/settings/JobsPanel";

export function SettingsJobsPage() {
  return <JobsPanel />;
}
